import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Role } from '../../../core/models/role.model';
import { LoggingService } from '../../../core/services/logging.service';
import { BaseRepository } from './base.repository';
import envConfig from '../../../env-config';

@Injectable({ providedIn: 'root' })
export class RolesRepository extends BaseRepository {
  private readonly http = inject(HttpClient);
  private readonly logger = inject(LoggingService);
  private readonly apiUrl = envConfig.bffUrl ?? '';

  getRoles(): Observable<Role[]> {
    this.logger.debug('RolesRepository: Fetching roles from API');

    return this.http
      .get<Role[]>(`${this.apiUrl}/api/v1/role`, {
        context: this.authContext(),
      })
      .pipe(
        tap(result =>
          this.logger.debug('RolesRepository: Roles fetched', {
            count: result.length,
          })
        ),
        catchError(error => {
          this.logger.error('RolesRepository: Failed to fetch roles', error);
          return of([]);
        })
      );
  }
}
